import { HttpErrorResponse } from '@angular/common/http';

import { createActions, ngrxEvent } from '@core/ngrx-legacy';

export const IntelligenceAnalyticsActions = createActions('IntelligenceAnalytics', {
  track: ngrxEvent<{ event: string; data: { requestId: string; [k: string]: unknown } }>(),
  trackSuccess: ngrxEvent<{ event: string }>(),
  trackFailed: ngrxEvent<{ event: string; error: HttpErrorResponse }>(),
});
